import { render } from "./LicenseFeaturesContent.vue?vue&type=template&id=9334768a&ts=true"
import script from "./LicenseFeaturesContent.vue?vue&type=script&lang=ts"
export * from "./LicenseFeaturesContent.vue?vue&type=script&lang=ts"

import "./LicenseFeaturesContent.vue?vue&type=style&index=0&id=9334768a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__